/**
 * NumberField for SchemaForm — renders a JSON-Schema `number` or `integer` property.
 * `valueAsNumber: true` ensures the submitted value is a JS number, not a string.
 */

import { useFormContext, type FieldValues } from 'react-hook-form';
import styles from '../SchemaForm.module.css';
import type { SchemaFieldProps } from './TextField';

export function NumberField({ name, sub, required }: SchemaFieldProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext<FieldValues>();
  const error = errors[name];
  return (
    <label className={styles.field}>
      <span>
        {name}
        {required ? ' *' : ''}
      </span>
      <input
        type="number"
        {...register(name, {
          required,
          valueAsNumber: true,
          min: sub.minimum,
          max: sub.maximum,
        })}
        aria-label={name}
        step={sub.type === 'integer' ? 1 : 'any'}
      />
      {sub.description && <small>{sub.description}</small>}
      {error && (
        <small className={styles.error}>
          {typeof error.message === 'string' && error.message.length > 0
            ? error.message
            : 'Required'}
        </small>
      )}
    </label>
  );
}
